import React from 'react';
import { DirectionToggle } from '../shared/DirectionToggle';

interface RiseFallParamsProps {
  direction: 'rise' | 'fall';
  duration: string;
  allowEquals: boolean;
  onDirectionChange: (direction: 'rise' | 'fall') => void;
  onDurationChange: (duration: string) => void;
  onAllowEqualsChange: (allowEquals: boolean) => void;
}

const RiseFallParams: React.FC<RiseFallParamsProps> = ({
  direction,
  duration,
  allowEquals,
  onDirectionChange,
  onDurationChange,
  onAllowEqualsChange
}) => {
  return (
    <>
      <div className="parameter-group">
        <label>Direction</label>
        <DirectionToggle
          leftLabel="Rise"
          rightLabel="Fall"
          selectedDirection={direction}
          onDirectionChange={(dir) => onDirectionChange(dir as 'rise' | 'fall')}
        />
      </div>

      <div className="parameter-group">
        <label>Duration</label>
        <select 
          className="input-field" 
          value={duration}
          onChange={(e) => onDurationChange(e.target.value)}
        >
          <option value="1 minute">1 minute</option>
          <option value="5 minutes">5 minutes</option>
          <option value="15 minutes">15 minutes</option>
          <option value="30 minutes">30 minutes</option>
          <option value="1 hour">1 hour</option>
        </select>
      </div>

      <div className="parameter-group">
        <label>Allow Equals</label>
        <label className="checkbox-container">
          <input 
            type="checkbox" 
            className="checkbox-input"
            checked={allowEquals}
            onChange={(e) => onAllowEqualsChange(e.target.checked)}
          />
          <span className="checkbox-custom"></span>
          <span className="checkbox-label">Win if price equals entry</span>
        </label>
      </div>
    </>
  );
};

export default RiseFallParams;
export { RiseFallParams };
